<template>
  <data-table
    model="App\Sms">

    <template v-slot:empty-head>
      <v-icon size="72" :color="$store.getters.app.color_name">contacts</v-icon>
    </template>

    <template v-slot:empty-text>
      <p class="subheading">Emails tmeplate will appear in this list </p>
    </template>

  </data-table>
</template>
<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>